module.exports = "/_next/static/images/bbff78e8acfdc2e41b931a1b1af78e26-rewards-hosting@2x.png.webp";